// extracted by mini-css-extract-plugin
export var searchHeader = "_8b-0";
export var searchHeaderDark = "_8b-1";